module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playlist"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        video: _vm.player.index === index && _vm.player.video, audio: _vm.player.index === index && _vm.player.audio
      }
    }, [_c('a', {
      staticClass: "name",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onPlayVideo(index, true)
        }
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('a', {
      staticClass: "icon icon-play-o",
      class: {
        off: !item.mp4
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onPlayVideo(index, false)
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "icon icon-music1",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onPlayAudio(index)
        }
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f901e56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/movie/PlayList.vue
// module id = 333
// module chunks = 0